import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
// UpcomingView is the landing route — needed on virtually every cold entry, so
// it ships in the main bundle (NOT lazy) and renders directly with the shell.
// No <Suspense> wraps it: it's local-first (SQLite reads resolve in ~50ms) and
// hydrates synchronously from the TanStack cache, so a fallback would only
// flash + cause a remount. All its queries are non-suspending.
import { UpcomingView } from "@/features/reminders/components/upcoming-view";
import { AppErrorBoundary } from "@/components/ui/error-boundary";

function UpcomingPage() {
  return (
    <AppErrorBoundary region label="upcoming">
      <UpcomingView />
    </AppErrorBoundary>
  );
}

export const indexRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/",
  component: UpcomingPage,
});
